const Page = require('./blocks/pages/Page');
const NavigationSelectedContextPage = require('./blocks/pages/NavigationSelectedContextPage');
const BuilderBase = require('./blocks/BuilderBase');
const findHNode = require('./findHNode');
const blocks = require('./blocks');

function testTree(pageTitle, properties, namespaces) {
    if (pageTitle != null) {
        return new Page(pageTitle, properties, namespaces);
    }
}

testTree.findHNode = findHNode;
testTree.page = function page(pageTitle, properties, namespaces) {
    return new Page(pageTitle, properties, namespaces);
};

testTree.navigationSelectedContextPage = function navigationSelectedContextPage(pageTitle, properties, namespaces) {
    return new NavigationSelectedContextPage(pageTitle, properties, namespaces);
};

module.exports = testTree;

if (BuilderBase.blockTypes == null) {
    registerBlockTypes();
}

// Avoid circular references by registering blocks (instead of putting dependency block require
// functions on top of page).  If you run into a TypeError: "<some block> is not a constructor",
// you probably have a circular reference.  To fix it, remove the require for that block from
// the top of that file and instead, construct the block like this:
// `const someBlockVar = Builder.blockTypes[<some block's NodeType>](title, properties)`
// example: `const form = Builder.blockTypes['Form'](title, properties)`
function registerBlockTypes() {
    BuilderBase.blockTypes = {};
    registerSubBlocks(blocks);
}

function registerSubBlocks(indexBlock) {
    Object.entries(indexBlock).forEach(([key, value]) => {
        BuilderBase.blockTypes[key] = value;
        if (typeof value === 'object') {
            registerSubBlocks(value);
        }
    });
}
